<script>
import { driver } from 'driver.js'
import 'driver.js/dist/driver.css'

// penanda disimpan di cookie karena localStorage dibersihkan setiap login/logout
const COOKIE_PANDUAN = 'guideline_validasi_aktivitas'

// panduan yang menyorot langsung komponen baru pada halaman validasi aktivitas
export default {
  data: () => ({
    tur:null,
    timer:null,
  }),

  beforeDestroy(){
    clearTimeout(this.timer)
    if (this.tur){
      this.tur.destroy()
    }
  },

  render(){
    return null
  },

  methods:{
    sudahDilihat(){
      try{
        return document.cookie.split('; ').indexOf(COOKIE_PANDUAN + '=1') != -1
      } catch (e){
        return false
      }
    },

    tandaiDilihat(){
      try{
        // berlaku 5 tahun
        document.cookie = COOKIE_PANDUAN + '=1; max-age=' + (60*60*24*365*5) + '; path=/'
      } catch (e){
        // abaikan, panduan akan tampil lagi pada kunjungan berikutnya
      }
    },

    judul(icon, color, teks){
      let warna = this.$vuetify.theme.currentTheme[color]
      return '<span class="panduan-ikon" style="background-color:' + warna + '"><i class="mdi ' + icon + '"></i></span>' + teks
    },

    isi(teks, poin){
      let baris = (poin || []).map(x => {
        let warna = this.$vuetify.theme.currentTheme[x.color]
        return '<div class="panduan-poin"><i class="mdi ' + x.icon + '" style="color:' + warna + '"></i><span>' + x.teks + '</span></div>'
      })
      return '<p>' + teks + '</p>' + baris.join('')
    },

    // dipanggil halaman setelah data pertama selesai dimuat, hanya tampil sekali
    mulaiOtomatis(){
      if (!this.sudahDilihat()){
        // tunggu halaman selesai dirender agar posisi sorotan tepat
        clearTimeout(this.timer)
        this.timer = setTimeout(this.mulai, 600)
      }
    },

    mulai(){
      if (this.tur){
        return
      }

      // buka pegawai pertama agar tombol terima / tolak bisa disorot
      this.$emit('mulai')
      this.$nextTick(this.jalankan)
    },

    jalankan(){

      let steps = [
        {
          element:'#panduan-val-kalender',
          popover:{
            title:this.judul('mdi-calendar-cursor', 'primary', 'Pilih Tanggal'),
            description:this.isi('Klik tanggal di kalender untuk melihat aktivitas bawahan pada tanggal tersebut.', [
              {icon:'mdi-circle', color:'info', teks:'Biru / coklat &ndash; <b>menunggu</b> validasi'},
              {icon:'mdi-circle', color:'success', teks:'Hijau &ndash; sudah <b>disetujui</b>'},
              {icon:'mdi-circle', color:'error', teks:'Merah &ndash; <b>ditolak</b>'},
            ]),
          }
        },
        {
          element:'#panduan-val-ringkasan',
          popover:{
            title:this.judul('mdi-filter-variant', 'info', 'Baru: Ringkasan & Filter'),
            description:this.isi('Jumlah aktivitas pada tanggal yang dipilih. Klik salah satu untuk menyaring daftar, klik lagi untuk menampilkan semua.'),
          }
        },
        {
          element:'#panduan-val-pegawai',
          popover:{
            title:this.judul('mdi-account-group', 'primary', 'Baru: Daftar Pegawai'),
            description:this.isi('Aktivitas kini tampil langsung di sini, tidak lagi di jendela terpisah.', [
              {icon:'mdi-chevron-down', color:'primary', teks:'Klik nama pegawai untuk membuka aktivitasnya'},
              {icon:'mdi-timer-sand', color:'info', teks:'Angka biru = jumlah yang <b>menunggu</b>'},
            ]),
          }
        },
        {
          element:'.panduan-val-aksi',
          popover:{
            title:this.judul('mdi-check-decagram', 'success', 'Terima atau Tolak'),
            description:this.isi('Validasi setiap aktivitas langsung dari kartunya.', [
              {icon:'mdi-check-circle', color:'success', teks:'<b>Terima</b> &ndash; cukup satu klik'},
              {icon:'mdi-close-circle', color:'error', teks:'<b>Tolak</b> &ndash; isi alasan penolakan'},
            ]),
          }
        },
        {
          element:'.panduan-val-semua',
          popover:{
            title:this.judul('mdi-check-all', 'success', 'Baru: Terima Semua'),
            description:this.isi('Setujui seluruh aktivitas yang masih menunggu milik satu pegawai sekaligus, tanpa perlu membuka daftarnya.'),
          }
        },
      ]

      // lewati langkah yang komponennya tidak sedang tampil (mis. tidak ada aktivitas pada tanggal ini)
      steps = steps.filter(x => document.querySelector(x.element))
      if (steps.length == 0){
        return
      }

      this.tur = driver({
        showProgress:true,
        progressText:'{{current}} dari {{total}}',
        nextBtnText:'Lanjut',
        prevBtnText:'Kembali',
        doneBtnText:'Mengerti',
        popoverClass:'panduan-popover',
        overlayOpacity:0.6,
        stagePadding:6,
        stageRadius:8,
        steps:steps,
        onDestroyed:() => {
          this.tur = null
          this.tandaiDilihat()
        }
      })

      this.tur.drive()
    }
  }
}
</script>

<style lang="scss">
  @import '~@/sass/panduan.scss';
</style>
